// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientExternalDocuments = createAction(
  'SET_PATIENT_EXTERNAL_DOCUMENTS'
)

export const resetPatientExternalDocuments = createAction(
  'RESET_PATIENT_EXTERNAL_DOCUMENTS'
)
